import {
  getFragmentData,
  execute,
  logGraphQLDebug,
  ProductFragment,
  GetProductBySkuDocument,
  GetProductDetailsPageDocument,
  ProductFragmentDoc,
  ProductReviewFragmentDoc,
  ProductReviewFragment,
  GetProductsDocument
} from '@/fo/api/magento';

const getProductBySku = async (
  sku: string
): Promise<ProductFragment | null | undefined> => {
  const result = await execute(GetProductBySkuDocument, {
    sku
  });

  logGraphQLDebug(result, 'GetProductBySku');

  if (result.data?.products?.items?.[0]) {
    return getFragmentData(
      ProductFragmentDoc,
      result.data?.products?.items?.[0]
    );
  }
  return null;
};

const getProductsBySkus = async (
  skus: string[]
): Promise<(ProductFragment | null)[]> => {
  if (skus.length === 0) return [];

  const result = await execute(GetProductsDocument, {
    filter: { sku: { in: skus } },
    pageSize: skus.length,
    page: 1
  });

  logGraphQLDebug(result, 'GetProductsBySkus');

  const products = result.data?.products?.items?.filter(
    (product) => product !== null
  ) as ProductFragment[];

  return skus.map(
    (sku) => products.find((product) => product.sku === sku) || null
  );
};

const getProductDetailsPage = async (
  productId: string
): Promise<
  | {
      product: ProductFragment;
      reviews: ProductReviewFragment[];
    }
  | null
  | undefined
> => {
  const result = await execute(GetProductDetailsPageDocument, {
    productId
  });

  logGraphQLDebug(result, 'GetProductDetailsPage');

  if (result.data?.products?.items?.[0]) {
    return {
      product: getFragmentData(
        ProductFragmentDoc,
        result.data?.products?.items?.[0]
      ),
      reviews: result.data?.products?.items?.[0]?.reviews?.items
        .map((item) => getFragmentData(ProductReviewFragmentDoc, item))
        .filter((item) => item !== null)
    };
  }
  return null;
};

export const productService = {
  getProductBySku,
  getProductsBySkus,
  getProductDetailsPage
};
